var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-divider"},[_c('span',{staticClass:"section-divider__title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"section-divider__line",attrs:{"aria-hidden":"true"}}),(_vm.$slots.actions)?_c('div',{staticClass:"section-divider__actions"},[_vm._t("actions")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }